import * as FileSaver from 'file-saver';

const exportHistory = (data: any) => {
    const exportData = data?.dailyEmployeeDimension;
    const expAge = [{}];
    expAge.push({
        'Employee': `${data.employee}`,
        'Manager Level': `${data.manager_level}`, 
    });
    for (let i = 0; i < exportData.length; i++) {
        expAge.push({             
            'Date': `${exportData[i].csr_dt}`,
            'Job Title': `${exportData[i].job_title}`,
            'Employment Type': `${exportData[i].employment_type}`,
            'Project': `${exportData[i].project}`,
            'Program': `${exportData[i].program}`,
            'Client': `${exportData[i].client}`,
            'Parent Client': `${exportData[i].parent_client}`,
            'Site': `${exportData[i].site}`,
            'Scorecard Name': `${exportData[i].scorecard_name}`,
            'Team Lead': `${exportData[i].team_lead}`,
            'Manager': `${exportData[i].manager}`,
            'Hire Tenure Days': `${exportData[i].hire_tenure_days}`,
            'Proj Tenure Days': `${exportData[i].proj_tenure_days}`,
        });
    }
    return expAge;
};

export const exportExcel = (data: any, fileName: string) => {
    import('xlsx').then((xlsx: any) => {
        const worksheet = xlsx.utils.json_to_sheet(exportHistory(data));
        const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
        const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        saveAsExcelFile(excelBuffer, fileName);
    });
};

export const saveAsExcelFile = (buffer: any, fileName: string) => {
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';
    const data = new Blob([buffer], {
        type: EXCEL_TYPE,
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
};
